export interface PedidosMmaxEccomerce {
    iddocumento: number;
    clienteol: number,
    documento: number,
    estado: string,
    idPedido: number,
    gestion: number,
    items: any[],
    medios: MediosPagos[],
    tipoformulario: number,
    modo: number,
    monto: number
}
export interface ItemsMMaxResumen {
    cantidad: number,
    codigo: number,
    marca: number,
    monto: number,
    precio: number,
    fraccion: number,
}

export interface MediosPagos {
    fiid: string,
    mediopago: number,
    nombre: string,
    id?: string;
    selecionado?: boolean;
}
